/*
 * @Author: wyh
 * @Date: 2019-06-25 14:59:04
 * @Last Modified by: wyh
 * @Last Modified time: 2019-07-18 17:27:40
 * @Description: 定义跨模块，全局的常量
 */
export const INVARIANT = {
  //系统相关使用前缀_SYS_
  _SYS_SETUP_FLAG: "mpcBV_setup_flag", //首次安装标志名称
  _SYS_LOCAL_LANGUAGE: "mpcBV_local_language", //app保存的语言设置
  _SYS_THEME: "mpcBV_theme", //系统主题
  _SYS_BADGE_SUPPORT_PERMISSION: "mpcBV_badge_support", //是否支持角标
  _SYS_LOCAL_NOTIFICATION_SUPPORT_PERMISSION: "mpcBV_localNotification_support", //是否支持本地推送
  _SYS_CODELIST: "mpcBV_codelist", //字典表 用于国际化或一些其它
  _SYS_DOCKIND: "mpcBV_claimType", //字典表 单据或业务类型
  _SYS_AREADATAS: "mpcBV_areaDatas", //地区
  _SYS_WECHAT_ACCESSTOKEN: "mpcBV_qyWechate_actn", //企业微信accesstoken
  //请求相关 前缀  _REQUEST
  _REQUEST_TIMEOUT: 30000, //请求超时最大时间
  _LOCAL_NOTIFICAL_INTIVAL: 50000, //本地拉取通知间隔
  _REQUEST_USERID: "userId", //http请求时 保存用户id的key
  _REQUEST_TOKEN: "securityId", //http请求时 保存安全令牌的key
  //事件相关 前缀 _EVENTS
  _EVENTS_BADGE: "events: badge", //角标/代办数量通知
  _EVENTS_PAGEBACK: "events: pageBack", //页面返回 刷新的页面直接获取页面名称和参数
  //用户相关的信息前缀用_USER_ 退出时统一清理
  _USEFLAG: "_USER_", //退出时用该标志判断是否清楚storage信息
  _USER_USERINFO: "_now_userinfo", //当前登录用户信息
  _USER_FINGER_GESER: "_finger_geser", //用户手势密码 --加上用户id作为前缀如 kevin_finger_geser
  _USER_USE_TOUCHID: "_set_touchid", //用户是否启用了指纹 --加上用户id作为前缀如 kevin_finger_geser
  _USER_ISSHOWHOMETEM: "_is_show_hometem", //是否展示home2 --加上用户id作为前缀如 kevin_finger_geser
  _USER_SHOWHOMTEM: "_showing_hometem", //home2 展示的项 --加上用户id作为前缀如 kevin_finger_geser

  _USERID: "id", //存储用户相关信息至本地时 使用的用户唯一标识字段
};

export const SYS_ENCRYPT = {
  _PublicKey: `-----BEGIN PUBLIC KEY-----
    MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAujTr5Bz+yLlTpqwgcTBT
    2AI55nAiXjciqH7IKz6pGl+neEL/f7HmOFnwBYNQMqlXq/UCCI8ddk+4JebkAGeg
    8sg4M+jlHy9Vissp90WHj0le45EZSMup4e6V+5vYTUMST6ozO6YKI5E/zy399FwW
    MppaLt8r62oJBrDe4+rSj7iY5EUchTNYceoNK1uWbzG21jdL/tsXx5KAgq21DLGR
    4aCBgEB8e5We82XlYbge0rIhko6j60xwmW9oE6Mw0w5KyvOoFwVvlG2vCMO/ph9v
    lkEzB/fsmYH5EpwgOrPaett7sYqNpqiUl5kbTbFDMdyrGNgtAc+o7R4vNmCuO2iO
    1QIDAQAB
    -----END PUBLIC KEY-----`,
  _Salt: `8d&jj936b4dh&fsih%45fids`,
  _G: "#*#",
};



// WEBPACK FOOTER //
// ./src/config/invariant.config.ts